import React from 'react';
import {
  styled,
  Text,
  TextAlignment,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import {FindCar} from '@volkswagen-onehub/icons-core';
import {getTranslations} from '../../translations';

const HomeHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.size.static200};
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: ${({ theme }) => theme.size.static200};
  svg {
    margin: -0.11em 0 0.11em 0;
    font-size: var(--textappearances-headline400-fontsize);
    line-height: var(--textappearances-headline400-lineheight);
  }
`;

export const HomeHeader = () => {
  const { search_modal: copy } = getTranslations();

  return (
    <HomeHeaderContainer>
      <HeaderWrapper>
        <FindCar variant="large" ariaHidden />
        <Text
          tag={TextTag.h2}
          appearance={TokenTextAppearance.headline500}
          textAlign={TextAlignment.center}
        >
          <Text bold>{copy.header[0]}</Text> {copy.header[1]}
        </Text>
      </HeaderWrapper>

      <Text
        tag={TextTag.p}
        appearance={TokenTextAppearance.copy200}
        textAlign={TextAlignment.center}
      >
        {copy.subhead}
      </Text>
    </HomeHeaderContainer>
  );
};
